<template>
	<div class="page-mdl">
		
		<!-- 一级栏目 -->
		<div class="tabs-first">
			<div class="swiper-container w1200" :class="{'swiper-show':tabsFirstList.length<=tabsFirstMaxNum}" id="tabsFirstSwiper" >
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in tabsFirstList" :key="item.catid">
						<span :class="{act:index==tabsFirstIndex}" @click="tabsFirstTag(index)">{{item.catename}}</span>
					</div>
				</div>
			</div>
			<span v-if="tabsFirstList.length>tabsFirstMaxNum" :class="{disabled:firstSwiperIndex==0}" class="prev" @click="tabsFirstSwiperChange('prev')"><i></i></span>
			<span v-if="tabsFirstList.length>tabsFirstMaxNum" :class="{disabled:firstSwiperIndex==tabsFirstList.length-tabsFirstMaxNum}" class="next" @click="tabsFirstSwiperChange('next')"><i></i></span>
		</div>
		
		<div class="index-cont">
			
			<!-- 二级栏目 -->
			<div class="tabs-second" v-if="tabsSecondList.length>0">
				<div class="swiper-container w1200" :class="{'swiper-show':tabsSecondList.length<=tabsSecondMaxNum}" id="tabsSecondSwiper" >
					<div class="swiper-wrapper">
						<!-- <div class="swiper-slide" v-if="tabsSecondList.length>1">
							<span :class="{act:tabsThirdNowCatid==''}" @click="tabsSecondTag('')">全部分部</span>
						</div> -->
						<div class="swiper-slide" v-for="(item,index) in tabsSecondList" :key="item.catid">
							<span :class="{act:tabsSecondIndex==index}" @click="tabsSecondTag(index)">{{item.catename}}</span>
						</div>
					</div>
				</div>
				<span v-if="tabsSecondList.length>tabsSecondMaxNum" :class="{disabled:secondSwiperIndex==0}" class="prev" @click="tabsSecondSwiperChange('prev')"><i></i></span>
				<span v-if="tabsSecondList.length>tabsSecondMaxNum" :class="{disabled:secondSwiperIndex==tabsSecondList.length-tabsSecondMaxNum}" class="next" @click="tabsSecondSwiperChange('next')"><i></i></span>
			</div>
			
			<!-- 三级栏目 -->
			<div class="tabs-third" :class="{'swiper-show':tabsSecondList.length<=tabsSecondMaxNum}" v-if="tabsFirstList.length>0 ">
				<div class="w1200">
					<span :class="{act:tabsThirdNowCatid==''}" v-if="tabsThirdList.length>1" @click="tabsThirdTag('')">全部分部</span>
					<span :class="{act:tabsThirdNowCatid==item.catid}" v-for="(item,index) in tabsThirdList" :key="item.catid" @click="tabsThirdTag(item.catid)">{{item.catename}}</span>
				</div>
			</div>
			
			<!-- 分部信息l列表 -->
			<section class="activity-mdl" v-if="tabsFirstList.length>0 && tabsThirdList.length>0">
				<div class="first-title"><span>{{tabsFirstList[tabsFirstIndex].catename}}</span></div>
				<div class="cat-video" v-if="tabsSecondList.length>0 && tabsSecondList[tabsSecondIndex].video">
					<video class="video" :src="tabsSecondList[tabsSecondIndex].video" controls></video>
				</div>
				<div 
					class="activity-item" :class="{'gray-bg':(index%2==1&&tabsThirdNowCatid=='')}" 
					v-for="(item,index) in tabsThirdList" :key="item.catid"  v-show="item.catid==tabsThirdNowCatid || tabsThirdNowCatid==''"
				>
					<div class="w1200">
						<div class="second-title">{{item.catename}}</div>
						
						<!-- 文章类型 -->
						<ul class="article-list" v-if="item.tid==1">
							<li v-for="(item2,index2) in item.list" :key="item2.id" @click="goUrl({ name:'pageDetail', params:{ id:item2.id}})">
								<div class="date">
									<span class="day">{{item2.inputtime.substring(8,10)}}</span>
									<span class="year-month">{{item2.inputtime.substring(5,7)}}月<br>{{item2.inputtime.substring(0,4)}}</span>
								</div>
								<div class="info">
									<h4>{{item2.title}}</h4>
									<p>{{item2.description}}</p>
								</div>
							</li>
						</ul>
						
						<!-- 视频类型 -->
						<ul class="video-list" v-if="item.tid==3">
							<li v-for="(item2,index2) in item.list" :key="item.id">
								<div class="img" :style="'background-image:url('+ item2.thumb +');'" @click="goDetail(item2.id)"></div>
								<div class="btm">
									<div class="zan" :class="{act:item2.is_like==1}" @click="clickLike(item2,index,index2)">{{item2.like?item2.like:0}}</div>
									<div class="info">
										<p @click="goDetail(item2.id)">作品名称: {{item2.title}}</p>
										<p>学生姓名: {{item2.student_name}}</p>
									</div>
								</div>
							</li>
						</ul>
						<a href="javascript:;" class="more-btn" @click="moreGo(item.catid)">查看更多</a>
					</div>
				</div>
			</section>

		</div>
		
	</div>
</template>

<script>
import pageMixin from '@/mixins/page.js'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
	mixins: [pageMixin],
	name: 'pageIndex',
	data () {
		return {
			tabsFirstList:[],		//一级栏目
			tabsFirstIndex:-1,		//一级栏目索引
			tabsFirstMaxNum:4,		//一级栏目最大显示数量
			tabsSecondList:[],
			firstSwiperIndex:0,		//二级栏目幻灯片索引
			tabsSecondIndex:0,		//二级栏目索引
			secondSwiperIndex:0,	//
			tabsSecondMaxNum:5,		//二级栏目每个分部显示的最大条数
			tabsThirdList:[],
			tabsThirdNowCatid:'',	//当前选中的三级栏目catid
			
		}
	},
  
	computed:{
		// tabsSecondList(){
		// 	var list = []
		// 	if(this.tabsFirstList.length>0 && this.tabsFirstList[this.tabsFirstIndex].childCategory.length && this.tabsFirstList[this.tabsFirstIndex].type==1){
		// 		list = this.tabsFirstList[this.tabsFirstIndex].childCategory
		// 		this.clog('list2',list)
		// 		this.tabsSecondIndex = 0
		// 		this.secondSwiperIndex = 0
		// 		this.getxThirdCategory(list[0].catid)
		// 		setTimeout(()=>{
		// 			this.tabsSecondSwiper()
		// 		},300)
		// 	}
		// 	return list
		// },
		// tabsThirdList(){
		// 	var list = []
		// 	if(this.tabsFirstList.length>0 && this.tabsFirstList[this.tabsFirstIndex].childCategory.length && this.tabsFirstList[this.tabsFirstIndex].type==0){
		// 		list = this.tabsFirstList[this.tabsFirstIndex].childCategory
		// 		this.clog('list3',list)
		// 		this.tabsThirdList = list
		// 		this.tabsThirdNowCatid = ''
		// 	}
		// 	return list
		// }
	},
	
	watch:{
		tabsFirstIndex(){
			var list = (this.tabsFirstList.length>0 && this.tabsFirstList[this.tabsFirstIndex].childCategory.length)? this.tabsFirstList[this.tabsFirstIndex].childCategory:[]
			if(this.tabsFirstList[this.tabsFirstIndex].type==1){
				if(list.length>0){
					this.tabsSecondList = list
					this.tabsSecondIndex = 0
					this.secondSwiperIndex = 0
					this.getxThirdCategory(list[0].catid)
					setTimeout(()=>{
						this.tabsSecondSwiper()
					},300)
				}
			}else{
				if(list.length>0){
					this.tabsSecondList = []
					this.getxThirdCategory(this.tabsFirstList[this.tabsFirstIndex].catid)
					// this.tabsThirdList = list
					// this.tabsThirdNowCatid = ''
				}
			}
		}
	},
	
	mounted(){
		this.reachContent()
		// setTimeout(()=>{
		// 	this.tabsFirstSwiper()
		// 	this.tabsSecondSwiper()
		// },300)
		// if(this.yearCategory){
		// 	var catid = this.yearCategory[this.categoryIndex.first].child[this.categoryIndex.second].id
		// 	this.reachContent(catid)
		// }
	},
  
	methods:{
		
		//刷新下方信息
		reachContent(catid){
			this.getxFirstCategory()
		},

		//获取一级栏目列表
		getxFirstCategory(){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getTopCategory',
				success:(res)=>{
					var tabsFirstList = res.data
					this.tabsFirstList = tabsFirstList
					this.tabsFirstIndex = 0
					setTimeout(()=>{
						this.tabsFirstSwiper()
					},300)
					// this.getxThirdCategory(tabsFirstList[0].catid)
				}
			})
		},
		//一级栏目选项卡切换
		tabsFirstTag(index){
			this.tabsFirstIndex = index
			// this.getxThirdCategory(this.tabsFirstList[index].catid)
		},
		//一级栏目幻灯片
		tabsFirstSwiper(){
			var _this = this
			this.firstSwiper = new Swiper ('#tabsFirstSwiper', {
				loop: false,
				slidesPerView:this.tabsFirstMaxNum,
				onSlideChangeEnd: function(swiper){
				     _this.firstSwiperIndex = swiper.activeIndex
				}
			})
		},
		//一级栏目幻灯片左右切换
		tabsFirstSwiperChange(type){
			if(type=='prev'){
				this.firstSwiper.slidePrev();
			}else if(type=='next'){
				this.firstSwiper.slideNext();
			}
		},
		
		
		
		//改变二级栏目
		tabsSecondTag(index){
			if(this.tabsSecondIndex != index){
				this.getxThirdCategory(this.tabsSecondList[index].catid)
			}
			this.tabsSecondIndex = index
			
		},
		//二级栏目幻灯片
		tabsSecondSwiper(){
			var _this = this
			this.clog('二级栏目幻灯片')
			this.secondSwiper = new Swiper ('#tabsSecondSwiper', {
				loop: false,
				slidesPerView:this.tabsSecondMaxNum,
				onSlideChangeEnd: function(swiper){
				     _this.secondSwiperIndex = swiper.activeIndex
				}
			})
		},
		//二级栏目幻灯片左右切换
		tabsSecondSwiperChange(type){
			if(type=='prev'){
				this.secondSwiper.slidePrev();
			}else if(type=='next'){
				this.secondSwiper.slideNext();
			}
		},
		
		//获取二级栏目列表
		getSecondCategory(pid){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getListByDepartment',
				params:{
					pid:pid,	//顶级栏目id
					limit:6,	//显示条数 默认6条资讯文章
				},
				success:(res)=>{
					return
					var list = res.data
					this.tabsThirdList =list
					this.tabsThirdNowCatid = list.length>1?'':list[0].catid
				}
			})
		},
		
		//获取三级栏目列表
		getxThirdCategory(pid){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getChildCategory',
				params:{
					pid:pid,	//顶级栏目id
					limit:6,	//显示条数 默认6条资讯文章
				},
				success:(res)=>{
					var list = res.data
					this.tabsThirdList =list
					this.tabsThirdNowCatid = list.length>1?'':list[0].catid
				}
			})
		},
		
		//改变三级栏目
		tabsThirdTag(catid){
			this.tabsThirdNowCatid = catid
		},
		
		
		//点赞
		clickLike(item,index,index2){
			if(item.is_like==1){	//已点过赞
				return
			}
			this.$axios({
				url:'/index.php?s=common&c=api&m=like',
				params:{
					newId:item.id,	//顶级栏目id
				},
				success:(res)=>{
					this.tabsThirdList[index].list[index2].is_like = 1
					this.tabsThirdList[index].list[index2].like += 1
				}
			})
		},
		
		
		//更多跳转
		moreGo(catid){
			this.goUrl({ name:'pageList', params:{ catid:catid}})
			// if(!item.more){
			// 	this.goUrl({ name:'pageList', params:{ catid:item.catid}})
			// }else{
			// 	this.goUrlOut(item.more)
			// }
		},
		
		//跳转详情
		goDetail(id){
			this.goUrl({ name:'pageDetail', params:{ id:id}})
		},

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.gray-bg{background:#F6F6F6; }
.more-btn{display:flex; justify-content: center; align-items: center; box-sizing: border-box; margin:0 auto; width: 180px; height: 50px; background: #D41F10; border-radius: 25px; font-size: 14px; color:#fff; line-height:20px;}
.more-btn:hover{opacity: .8;}
.tabs-first{
	height: 80px; background: #FFFFFF; box-shadow: 0px 5px 30px 0px rgba(55, 2, 2, 0.12); position:relative;
	.swiper-container{
		width:1120px; margin:0 auto; box-sizing: border-box;
		.swiper-slide{
			span{
				display:block; width:100%; height:80px; text-align:center; display:flex; justify-content: center; align-items: center; font-size:18px; color:#637584; line-height:30px; box-sizing: border-box; cursor: pointer;
				&.act{background:#D41F10; color:#fff;}
			}
		}
	}
	.swiper-container.swiper-show{ width:1200px; }
	.prev,.next{ 
		display:flex; justify-content: center; align-items: center; width:40px; height:80px; position:absolute; top:0;  cursor: poitner; 
		i{display:inline-block; width:14px; height:18px; background:url(../../assets/img/arrow1.png) no-repeat; background-size:100% 100%;}
		&:hover{
			background:#ED0202;
			i{ background-image:url(../../assets/img/arrow1-act.png); }
		}
		&.disabled{ 
			&.prev{background: linear-gradient(90deg, #FFF3F2 0%, #FFFFFF 100%); }
			&.next{background: linear-gradient(90deg, #FFFFFF 0%, #FFF3F2 100%);}
			i{background-image:url(../../assets/img/arrow1.png);}
		}
	}
	.prev{
		left:50%; margin-left:-600px; background: linear-gradient(90deg, #FFF3F2 0%, #FFFFFF 100%); 
		i{transform: rotate(180deg);}
	}
	.next{right:50%; margin-right:-600px; background: linear-gradient(90deg, #FFFFFF 0%, #FFF3F2 100%);}
}

.tabs-second{
	 position:relative;
	.swiper-container{
		width:1120px; margin:0 auto;
		.swiper-slide{
			// span{
			// 	display:block; width:100%; height:80px; text-align:center; display:flex; justify-content: center; align-items: center; font-size:20px; color:#666666; line-height:30px; box-sizing: border-box; cursor: pointer;
			// 	&::before{ content:''; display:inline-block; width:1px; height:20px; background:#E5E5E5; position:absolute; left:0; top:50%; margin-top:-10px; }
			// 	&.act{ color:#D41F10; font-weight: bold;}
			// }
			span{
				display:block; width:100%;  text-align:left; display:flex; justify-content: flex-start; align-items: center; font-size:18px; line-height:26px; 
				padding:30px 20px 18px 0; color:#666666;box-sizing: border-box; cursor: pointer; position:relative; 
				&.act::before{ content:''; display:inline-block; width:60px; height:4px; background:#D41F10; position:absolute; left:0; bottom:0; }
				//&.act{ color:#D41F10; font-weight: bold;}
			}
			// &:first-child span::before{ display: none; }
		}
	}
	.swiper-container.swiper-show{ width:1200px; }
	.prev,.next{
		display:flex; justify-content: center; align-items: center; width:40px; height:40px; position:absolute; top:40px;  cursor: poitner; transition:all .3s;
		i{display:inline-block; width:14px; height:18px; background:url(../../assets/img/arrow2.png) no-repeat; background-size:100% 100%;}
		&:hover{
			background:#ED0202;
			i{ background-image:url(../../assets/img/arrow1-act.png); }
		}
		&.disabled{ 
			&.prev{background: linear-gradient(90deg, #FFF3F2 0%, #FFFFFF 100%); }
			&.next{background: linear-gradient(90deg, #FFFFFF 0%, #FFF3F2 100%);}
			i{background-image:url(../../assets/img/arrow1.png);}
		}
	}
	.prev{
		left:50%; margin-left:-600px; background: linear-gradient(90deg, #FFF3F2 0%, #FFFFFF 100%); 
		i{transform: rotate(180deg);}
	}
	.next{right:50%; margin-right:-600px; background: linear-gradient(90deg, #FFFFFF 0%, #FFF3F2 100%);}
}
.tabs-third{
	margin:20px auto 0; width:1120px;
	&.swiper-show{ width:1200px; }
	span{ 
		display:inline-block; height:32px; line-height:32px; padding:0 10px; border:1px solid #E8E8E8; border-radius:4px; background:#fff; font-size:16px; color:#666666; text-align:center; margin-right:20px; cursor: pointer; margin-bottom:10px;
		&.act{ background:#FFEEED; color:#D41F10; }
	}
}

.activity-mdl{
	padding-top:70px;
	.first-title{ 
		display:flex; align-items: center; justify-content: center; height:50px; 
		span{font-size:28px; color:#D41F10; font-weight:bold; position:relative; z-index:10;}
		&::before,
		&::after{ content:''; display:inline-block; width:150px; height:38px; background:url('../../assets/img/ico-tit1.png') no-repeat center center; background-size:100% 100%; position:relative; top:10px;}
		&::before{left:40px;}
		&::after{ background-image:url('../../assets/img/ico-tit2.png'); left:-40px;}
	}
	.cat-video{
		width:800px; height:450px;  margin:40px auto 0; background:#000;
		.video{ width:100%; height:100%; }
	}
	.activity-item{
		padding:70px 0;
		.second-title{ 
			font-size:22px; color:#1E2533; line-height:30px; padding-bottom:12px; position:relative; font-weight: bold; margin-bottom:30px; margin-left:20px;
			&::before{ content:''; display:inline-block; width:40px; height:4px; background:#D41F10; position:absolute; bottom:0; left:0; }
		}
		.video-list{
			display:flex; justify-content: space-between; flex-wrap:wrap; padding:0 20px; margin-bottom:-40px;
			li{
				font-size:0px; line-height:0px; width: 360px; box-shadow: 0px 5px 59px 0px rgba(55, 2, 2, 0.1); background:#fff; margin-bottom:40px;
				.img{ width:100%; height:200px; background-size:cover; background-color:#ccc; cursor: pointer;}
				.btm{
					padding:15px 60px 15px 20px; position:relative;
					.zan{ 
						width:40px; font-size:12px; color:#999999; text-align:center; padding-top:30px; position:absolute; right:10px; top:50%; margin-top:-20px; line-height: 16px; cursor: pointer;
						 background:url(../../assets/img/ico-zan.png) no-repeat top center; background-size:24px 24px;
						 &.act{ background-image:url(../../assets/img/ico-zan2.png)}
					}
					p{ font-size:16px; color:#1E2533; line-height:28px; display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden;}
					p:first-child{cursor: pointer;}
				}
			}
		}
		.article-list{
			display:flex; justify-content: space-between; flex-wrap:wrap; padding:0 20px;
			li{
				 overflow:hidden;  cursor: pointer; padding:15px 0; border-bottom:1px solid #CCCCCC; width:48%;
				.date{
					float:left; width:164px; color:#637584; display:flex; align-items: center; height:80x;
					.day{ display:inline-block; font-size:50px; line-height:80px; }
					.day::after{content:'/'; display:inline-block; line-height:70px; font-size:26px; margin:0 4px; vertical-align: top; color:#637584; }
					.year-month{ display:inline-block; font-size:22px; line-height:40px; text-align: right;}
					
				}
				.info{
					overflow:hidden;
					h4{display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; font-size:20px; color:#1E2533; line-height:40px; margin-bottom:8px; }
					p{ max-height:40px; font-size:14px; color:#999999; line-height:20px; display: block; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 2; }
					.btn{ display:inline-block; font-size:12px; color:#D41F10; line-height:20px; margin-top:10px; font-weight: bold;}
				}
			}
			li:hover{
				.info h4{color:#D41F10;}
			}
		}
		.more-btn{margin-top: 40px;}
		&.gray-bg .more-btn{ background:#fff; border:1px solid #D41F10; color:#D41F10; }
	}
	
}


</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue